import { render, staticRenderFns } from "./ManageSubMenu.vue?vue&type=template&id=18e23b44"
import script from "./ManageSubMenu.vue?vue&type=script&lang=js"
export * from "./ManageSubMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports